module.exports = __webpack_public_path__ + "static/media/IconTemplates_-06.1efa7d2b.svg";